module.exports = __webpack_public_path__ + "img/offer.45f3e06.svg";